import React, { useEffect, useState } from "react";
import SideBar from "../../Components/Navbar/Sidebar";
import Modal from "react-modal";
import Pajination from "../../helpingFiles/Pagination/Pajination";
import Head from "../../Components/ontabletop/head";
import { createVendorData, updateCampaignApi, vandorDetails } from "../../Components/Apis/apis";
import instance from "../../Components/Apis/axios";
import Loader from "../../Components/loader";
import { toast, ToastContainer } from "react-toastify";
const headers = [
  // { key: "id", label: "ID" },
  { key: "Campaign Name", label: "Campaign Name" },
  { key: "Person", label: "Created by" },
  { key: "start_date", label: "start_date" },
  { key: "end_date", label: "end_date" },
  { key: "vendors", label: "Vendors" },
  { key: "action", label: "Add new Vendor" },
  { key: "editCamp", label: "Edit campaign" }
];
const initialState = {
  contact_email: "",
  contact_phone: "",
};

const Audit = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [posts, setPosts] = useState(initialState);
  const [check, setCheck] = useState("");
  const [createVendorModel, setcreateVendorModel] = useState(false);
  const [name, setName] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [sdate, setSdate] = useState(today);
  const [edate, setEdate] = useState(today);
  const [campaignID, setCampaignID] = useState();
  const [campaignVendor, setCampaignVendor] = useState([]);
  const [vandor, setvandor] = useState([]);
  const [address, setAddress] = useState([]);
  const [vendorlist, setvendorlist] = useState([]);
  const [Allcampaign, setAllcampaign] = useState([]);
  const [selectCampaign,setSelectCampaign]=useState();
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [postPerpage, setPostPerPage] = useState(10);
  const [query, setQuery] = useState("");

  const { contact_email, contact_phone } = posts;
  const create = async (e) => {
    if (name === "") {
      alert("Please write capmpaign name");
      return;
    }

    e.preventDefault();
    const { data } = await instance.put("vendorData/loginVendor", {
      name,
      sdate,
      edate,
    });
    if (data === "Sucess") {
      allData();
      setOpen(!open);
      setName("");
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setPosts({ ...posts, [name]: value });
  };

  const addVendor = async (e) => {
    e.preventDefault();
    let password, userid;
    const campaign_id = campaignID;
    if (check) {
      password = Math.floor(Math.random() * 100000);
      userid = Math.random().toString(36).substring(2, 9);
    }

    const data = await createVendorData(
      vandor,
      posts,
      userid,
      password,
      campaign_id
    );
    if (data.message == "Success") {
      setcreateVendorModel(!createVendorModel);
    }
  };

  const getAlladdress = async (vendor) => {
    setvandor(vendor);
    const data = await vandorDetails(vendor);
    setAddress(data);
  };

  const allData = async () => {
    setLoading(true);
    const { data } = await instance.get("vendorData/loginVendor");
    setAllcampaign(data);
    setLoading(false);
    setTotal(data.length);
  };

  const getList = async () => {
    const { data } = await instance.get("vendorData/vendor");

    setvendorlist(data);
  };
  const getCampaignVendor = async (id) => {
    const campaign_id = id;
    const { data } = await instance.get(
      `vendorData/campaignvendor/${campaign_id}`
    );
    setCampaignVendor(data);
  };

  useEffect(() => {
    allData();
  }, []);

  useEffect(() => {
    setPosts({ ...address[0] });
  }, [address]);
  const formatDate = (dateString) => {
    // Split the ISO string into date and time parts
    const [datePart] = dateString.split("T");
    // Split the date part into year, month, and day
    const [year, month, day] = datePart.split("-");
  
    // Format the date as "DD/MM/YYYY"
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  };
  // Get Current Posts (Pagination)
  const indexOfLastPage = page * postPerpage;
  const indexOfFirstPage = indexOfLastPage - postPerpage;
  const currentPosts = Allcampaign.slice(indexOfFirstPage, indexOfLastPage);

  const handleChangeEditCamp = (e, field) => {
    const value = e.target.value;
    setSelectCampaign(prevState => ({
      ...prevState,
      [field]: value
    }));
  };

  const updateCampaign = async () => {
    const data = await updateCampaignApi(selectCampaign);
    if (data.message === "Success") {
      setEditOpen(false);
      allData();
    
    }else{
      alert("Somthing went wrong!");
    }
  };
  
  return (
    <>
      <div className="containers">
        <div className="container-sidebar">
          <SideBar />
        </div>
        <div className="container-pages">
          <button onClick={(e) => setOpen(!open)} className=" mb-4 new-btn">
            New Campaign
          </button>

          <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />
          {loading ? (
            <Loader />
          ) : (
            <>
              {Allcampaign.length == 0 ? (
                <h2 className="text-secondary">No Campaign found</h2>
              ) : (
                <>
                  <table className="table table-boarder table-hover table-striped table-sm">
                    <thead className="thead-dark">
                      <tr>
                        {headers.map((row) => {
                          return <th key={row.key}>{row.label}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {Allcampaign &&
                        Allcampaign.filter((obj) => {
                          if (query === "") {
                            return obj;
                          } else if (
                            obj.campaign_name
                              .toLowerCase()
                              .includes(query.toLowerCase()) ||
                            obj.media_path_slug
                              .toString()
                              .toLowerCase()
                              .includes(query.toLowerCase())
                          ) {
                            return obj;
                          }
                        }).map((el) => (
                          <tr>
                            {/* <td>{el.id}</td> */}
                            <td>{el.campaign_name}</td>
                            <td>{el.media_path_slug}</td>
                            <td>{formatDate(el.start_date)}</td>
                            <td>{formatDate(el.end_date)}</td>
                            <td>
                              <select
                                className=" show-btn"
                                onClick={(e) => {
                                  getCampaignVendor(el.id);
                                }}
                              >
                                <option selected disabled>
                                  See all vendor
                                </option>
                                {campaignVendor &&
                                  campaignVendor.map((el) => (
                                    <option>{el.vendors}</option>
                                  ))}
                              </select>
                            </td>

                            <td>
                              <button
                                className="button is-small is-info show-btn border-0"
                                onClick={() => {
                                  setcreateVendorModel(!createVendorModel);
                                  getList();
                                  setCampaignID(el.id);
                                }}
                              >
                                Add Vendor
                              </button>
                            </td>

                            <td>
                              <button
                                className="button is-small is-info show-btn border-0"
                                onClick={(e) => {
                                  setSelectCampaign(el)
                                  setEditOpen(true)
                              
                                }}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>{" "}
                  </table>
                  <Pajination
                    setPostPerPage={setPostPerPage}
                    postPerpage={postPerpage}
                    page={page}
                    setPage={setPage}
                    total={total}
                  />
                </>
              )}
            </>
          )}
        </div>

         {/* add Campaign */}
        <Modal isOpen={open} className="mt-5 h-75 w-75">
          <button
            className="border-0 bg-info float-right"
            onClick={(e) => setOpen(!open)}
          >
            X
          </button>
          <br />
          <div className="">
            <label>Campaign Name</label>
            <input
              className="form-control m-0 my-2"
              type="text"
              onChange={(e) => setName(e.target.value)}
            />
            <label className="">Start Date</label>
            <input
              required
              type="date"
              className="form-control my-2"
              onChange={(e) => setSdate(e.target.value)}
              value={sdate}
              min={today}
            />
            <label className="">End Date</label>
            <input
              required
              className="form-control my-2"
              type="date"
              onChange={(e) => setEdate(e.target.value)}
              value={edate}
              min={today}
            />
          </div>
          <br />
          <button
            className="border-0 bg-info  float-right"
            onClick={(e) => create(e)}
          >
            Done
          </button>
        </Modal>

           {/* Edit Campaign */}
           <Modal isOpen={editOpen} className="mt-5 h-75 w-75">
          <button
            className="border-0 bg-info float-right"
            onClick={() => setEditOpen(!editOpen)}
          >
            X
          </button>
          <br />
          {selectCampaign && (
        <div className="">
          <label>Campaign Name</label>
          <input
            className="form-control m-0 my-2"
            type="text"
            value={selectCampaign.campaign_name}
            onChange={(e) => handleChangeEditCamp(e, 'campaign_name')}
          />
          <label className="">Start Date</label>
          <input
            required
            type="date"
            className="form-control my-2"
            value={selectCampaign.start_date.split('T')[0]} // Format start date
            min={selectCampaign.start_date.split('T')[0]}
            onChange={(e) => handleChangeEditCamp(e, 'start_date')}
          />
          <label className="">End Date</label>
          <input
            required
            className="form-control my-2"
            type="date"
            value={selectCampaign.end_date.split('T')[0]} // Format end date
            onChange={(e) => handleChangeEditCamp(e, 'end_date')}
          />
        </div>
      )}

        
          <br />
          <button
            className="border-0 bg-info  float-right"
            onClick={updateCampaign}
          >
            Done
          </button>
        </Modal>

      {/* add vendor */}
        <Modal isOpen={createVendorModel} className="mt-5 h-75 w-75">
          <button
            className="border-0 bg-info float-right"
            onClick={(e) => setcreateVendorModel(!createVendorModel)}
          >
            X
          </button>
          <br />
          <div className="">
            <form onSubmit={addVendor}>
              <label className="me-2">Vendor</label>
              <select
                className="me-2 form-control form-select" aria-label="Default select example"
                name="vandor"
                onChange={(e) => {
                  getAlladdress(e.target.value);
                  handleChange();
                }}
              >
                {vendorlist &&
                  vendorlist.map((el) => (
                    <option name="vandor">{el.name}</option>
                  ))}
              </select>

              <label className="me-2">Email</label>
              <input
                name="contact_email"
                type="email"
                className="me-2 form-control"
                value={contact_email}
                onChange={handleChange}
                required
              />
              <label className="me-2">Phone</label>
              <input
                name="contact_phone"
                type="number"
                className="me-2 form-control"
                value={contact_phone}
                onChange={handleChange}
                required
              />

              <input
                type="submit"
                className="m-5 me-0 float-right"
                value="Save"
              />
            </form>
          </div>
        </Modal>
      </div>
    </>
  );
};
export default Audit;
